import _objectSpread from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { getDict as _getDict } from "@/utils/dictionary";
export default {
  data: function data() {
    return {
      page: 1,
      total: 10,
      pageSize: 50,
      tableData: [],
      tableDataCount: {},
      searchInfo: {},
      pageCom: {}
    };
  },
  methods: {
    filterDict: function filterDict(value, type) {
      var rowLabel = this[type + "Options"] && this[type + "Options"].filter(function (item) {
        return item.value == value;
      });
      return rowLabel && rowLabel[0] && rowLabel[0].label;
    },
    getDict: function getDict(type) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var dicts;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _getDict(type);
            case 2:
              dicts = _context.sent;
              _this[type + "Options"] = dicts;
              return _context.abrupt("return", dicts);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.getTableData(val);
    },
    getTableData: function getTableData() {
      var _arguments = arguments,
        _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var page, pageSize, table;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              page = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : 1;
              pageSize = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : _this2.pageSize;
              _this2.page = page;
              _context2.next = 5;
              return _this2.listApi(_objectSpread({
                page: page,
                pageSize: pageSize
              }, _this2.searchInfo));
            case 5:
              table = _context2.sent;
              if (table.code == 0) {
                if (table.data != undefined && table.data != "") {
                  //兼容部分接口返回的空data不是对象而是空字符串
                  _this2.rspData = table.data;
                  if (table.data.total != undefined) {
                    _this2.total = table.data.total;
                  }
                  if (table.data.list != undefined) {
                    //兼容部分接口返回的空data.list不是数组而是空字符串
                    if (table.data.list != "") {
                      _this2.tableData = table.data.list;
                    } else {
                      _this2.tableData = [];
                    }
                  }
                  if (table.data.count != undefined) {
                    _this2.dataCount = table.data.count;
                    _this2.tableDataCount = table.data.count;
                  }
                  if (table.data.page != undefined) {
                    _this2.page = table.data.page;
                  }
                  if (table.data.pageSize != undefined) {
                    _this2.pageSize = table.data.pageSize;
                  }
                  if (table.data.page_size != undefined) {
                    _this2.pageSize = table.data.page_size;
                  }
                  if (table.data.columns != undefined) {
                    _this2.pageCom = table.data.columns;
                  }
                  if (table.data.total_number != undefined) {
                    _this2.total = table.data.total_number;
                  }
                }
              }
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }
};